import { defineComponent as _defineComponent } from 'vue'
export interface DotLoaderProps {
  size?: string | number;
  duration?: string | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dots-loader',
  props: {
    size: { default: 8 },
    duration: { default: 1 }
  },
  setup(__props: any) {





return { __sfc: true, }
}

})